import React from 'react';
import { StyleSheet, Pressable } from 'react-native';
import { YStack } from '@tamagui/stacks';
import { COLORS } from '@/constants/colors';
import { PHOTO_BORDER_RADIUS, LOCKED_PHOTO_HEIGHT } from '../constants';
import AuthenticatedImage from '@/components/AuthenticatedImage';

type GalleryPhotoProps = {
  imageUri: string;
  onPress: () => void;
  isDark?: boolean;
};

const GalleryPhoto = React.memo<GalleryPhotoProps>(({ imageUri, onPress, isDark }) => {
  const containerBg = isDark ? COLORS.ZINC_900 : COLORS.ZINC_200;
  
  const styles = StyleSheet.create({
    container: {
      borderRadius: PHOTO_BORDER_RADIUS,
      overflow: 'hidden',
      backgroundColor: containerBg,
    },
    image: {
      width: '100%',
      height: LOCKED_PHOTO_HEIGHT,
    },
  });
  
  return (
    <Pressable onPress={onPress}>
      <YStack style={styles.container}>
        <AuthenticatedImage 
          uri={imageUri}
          style={styles.image}
          resizeMode="cover"
        />
      </YStack>
    </Pressable>
  );
});

GalleryPhoto.displayName = 'GalleryPhoto';

export default GalleryPhoto;

